{
  "en": {
    "todo_list": {
      "actions": {
        "add": "Create Task List",
        "cancel": "Undo",
        "delete_todo_list": "Delete List",
        "edit": "Edit Task List",
        "new": "Task List",
        "save": "Save",
        "title": "List title"
      },
      "attributes": {
        "name": "Title"
      },
      "labels": {
        "assignToLevel": "Assign to level",
        "createdAt": "Created at",
        "filter_employee": "Responsible",
        "newTodoList": "New task list",
        "sort": {
          "created_at_asc": "Oldest first",
          "created_at_desc": "Newest first",
          "name_lower_asc": "Title A -> Z",
          "name_lower_desc": "Title Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Keep an overview of what you and your team have to do.",
            "title": "Open a new Task List"
          }
        }
      },
      "toasts": {
        "create": "Task list successfully created",
        "delete": "Task list has been successfully deleted",
        "update": "Task list has been successfully updated"
      },
      "validation": {
        "needTitle": "Title required"
      }
    }
  }
}
